var { initIframePrint } = require('./shared/iframe-print');

(function() {
    let itemIndex = 0;

    /**
     * Initialize the catering invoice generator
     */
    function init() {
        initIframePrint({
            formId: 'cigPrintForm',
            iframeId: 'cigPrintFrame',
            buttonId: 'cigPrintBtn',
            readyLabel: '<i class="bi bi-printer me-2" aria-hidden="true"></i>Print Invoice',
        });

        itemIndex = document.querySelectorAll('.item-row').length;

        const addItemBtn = document.getElementById('addItemBtn');
        if (addItemBtn) {
            addItemBtn.addEventListener('click', handleAddItem);
        }

        const loadSampleBtn = document.getElementById('cigLoadSampleBtn');
        if (loadSampleBtn) {
            loadSampleBtn.addEventListener('click', loadSampleData);
        }

        const editBtn = document.getElementById('cigEditBtn');
        if (editBtn) {
            editBtn.addEventListener('click', scrollToForm);
        }

        const clearBtn = document.getElementById('cigClearBtn');
        if (clearBtn) {
            clearBtn.addEventListener('click', showClearConfirmation);
        }

        const confirmClearBtn = document.getElementById('cigConfirmClearBtn');
        if (confirmClearBtn) {
            confirmClearBtn.addEventListener('click', function () {
                clearAllData();
                var modalEl = document.getElementById('cigClearConfirmModal');
                var modal = bootstrap.Modal.getInstance(modalEl);
                if (modal) {
                    modal.hide();
                }
            });
        }

        // Attach events to existing rows
        document.querySelectorAll('.item-row').forEach(attachRowEvents);

        // Remove item row handler
        document.addEventListener('click', function(e) {
            if (e.target.closest('.remove-item')) {
                handleRemoveItem(e);
            }
        });

        // Dynamic validation clearing
        attachValidationClearing();
    }

    /**
     * Attach input listeners to validated fields to clear error messages dynamically.
     */
    function attachValidationClearing() {
        var fields = [
            { input: 'input[name="Input.BusinessName"]', span: '[data-valmsg-for="Input.BusinessName"]' },
            { input: 'input[name="Input.ClientName"]', span: '[data-valmsg-for="Input.ClientName"]' },
            { input: 'input[name="Input.EventDate"]', span: '[data-valmsg-for="Input.EventDate"]' }
        ];

        fields.forEach(function(f) {
            var inputEl = document.querySelector(f.input);
            var spanEl = document.querySelector(f.span);
            if (inputEl && spanEl) {
                inputEl.addEventListener('input', function() {
                    if (inputEl.value.trim() !== '') {
                        spanEl.textContent = '';
                        spanEl.classList.remove('field-validation-error');
                        spanEl.classList.add('field-validation-valid');
                        dismissTopAlert();
                    }
                });
            }
        });
    }

    /**
     * Clear all visible validation messages (spans and top alert).
     */
    function clearAllValidation() {
        document.querySelectorAll('.field-validation-error').forEach(function(el) {
            el.textContent = '';
            el.classList.remove('field-validation-error');
            el.classList.add('field-validation-valid');
        });
        dismissTopAlert();
    }

    /**
     * Remove the top validation alert banner if all fields are now valid.
     */
    function dismissTopAlert() {
        var remaining = document.querySelectorAll('.field-validation-error');
        if (remaining.length === 0) {
            var alert = document.querySelector('#invoiceForm > .alert-warning');
            if (alert) {
                alert.remove();
            }
        }
    }

    /**
     * Handle adding a new item row
     */
    function handleAddItem() {
        const tbody = document.getElementById('itemsBody');
        const newRow = document.createElement('tr');
        newRow.className = 'item-row';
        newRow.innerHTML = `
            <td>
                <input type="text" class="form-control" name="Input.Items[${itemIndex}].Description" aria-label="Item description" />
            </td>
            <td>
                <input type="number" class="form-control item-qty" name="Input.Items[${itemIndex}].Quantity" value="1" min="0" step="1" aria-label="Quantity" />
            </td>
            <td>
                <div class="input-group">
                    <span class="input-group-text">$</span>
                    <input type="number" class="form-control item-price" name="Input.Items[${itemIndex}].UnitPrice" value="0" min="0" step="0.01" aria-label="Unit price" />
                </div>
            </td>
            <td>
                <span class="item-total fw-bold">$0.00</span>
            </td>
            <td>
                <button type="button" class="btn btn-outline-danger btn-sm remove-item" title="Remove item">
                    <i class="bi bi-x-lg" aria-hidden="true"></i>
                </button>
            </td>
        `;
        tbody.appendChild(newRow);
        itemIndex++;
        attachRowEvents(newRow);
    }

    /**
     * Handle removing an item row
     * @param {Event} e - The click event
     */
    function handleRemoveItem(e) {
        const row = e.target.closest('.item-row');
        if (document.querySelectorAll('.item-row').length > 1) {
            row.remove();
            reindexItems();
        }
    }

    /**
     * Attach event listeners to a row for real-time calculations
     * @param {HTMLElement} row - The row element
     */
    function attachRowEvents(row) {
        const qtyInput = row.querySelector('.item-qty');
        const priceInput = row.querySelector('.item-price');
        const totalSpan = row.querySelector('.item-total');

        function updateTotal() {
            const qty = parseFloat(qtyInput.value) || 0;
            const price = parseFloat(priceInput.value) || 0;
            totalSpan.textContent = '$' + (qty * price).toFixed(2);
        }

        qtyInput.addEventListener('input', updateTotal);
        priceInput.addEventListener('input', updateTotal);
    }

    /**
     * Reindex all items after removal to maintain sequential naming
     */
    function reindexItems() {
        document.querySelectorAll('.item-row').forEach((row, index) => {
            row.querySelectorAll('input').forEach(input => {
                const name = input.getAttribute('name');
                if (name) {
                    input.setAttribute('name', name.replace(/\[\d+\]/, `[${index}]`));
                }
            });
        });
        itemIndex = document.querySelectorAll('.item-row').length;
    }

    /**
     * Load sample catering invoice data
     */
    function loadSampleData() {
        // Business Information
        document.querySelector('input[name="Input.BusinessName"]').value = 'Asteria Bean Catering';
        document.querySelector('input[name="Input.BusinessAddress"]').value = '456 Culinary Way, Suite 100, Food City, CA 90210';
        document.querySelector('input[name="Input.BusinessPhone"]').value = '(555) 234-5678';
        document.querySelector('input[name="Input.BusinessEmail"]').value = 'info@asteriabean.com';

        // Client Information
        document.querySelector('input[name="Input.ClientName"]').value = 'John Doe';
        document.querySelector('input[name="Input.ClientAddress"]').value = '789 Celebration Lane, Happy Town, CA 90211';
        document.querySelector('input[name="Input.ClientPhone"]').value = '(555) 987-6543';
        document.querySelector('input[name="Input.ClientEmail"]').value = '';

        // Event Details
        const eventDate = new Date();
        eventDate.setDate(eventDate.getDate() + 30);
        document.querySelector('input[name="Input.EventDate"]').value = eventDate.toISOString().split('T')[0];
        document.querySelector('input[name="Input.EventTime"]').value = '18:00';
        document.querySelector('input[name="Input.EventLocation"]').value = 'Grand Ballroom, Riverside Hotel, 123 River Road';
        document.querySelector('input[name="Input.NumberOfGuests"]').value = '75';
        document.querySelector('select[name="Input.EventType"]').value = 'Wedding Reception';

        // Invoice Details
        const today = new Date();
        const dueDate = new Date();
        dueDate.setDate(dueDate.getDate() + 14);
        document.querySelector('input[name="Input.InvoiceNumber"]').value = 'INV-' + today.toISOString().slice(0, 10).replace(/-/g, '') + '-001';
        document.querySelector('input[name="Input.InvoiceDate"]').value = today.toISOString().split('T')[0];
        document.querySelector('input[name="Input.DueDate"]').value = dueDate.toISOString().split('T')[0];
        document.querySelector('input[name="Input.TaxRate"]').value = '8.25';

        // Sample Line Items
        const sampleItems = [
            { description: 'Appetizer Selection (per person)', quantity: 75, price: 12.00 },
            { description: 'Main Course - Herb Roasted Chicken (per person)', quantity: 45, price: 28.00 },
            { description: 'Main Course - Prime Rib (per person)', quantity: 30, price: 42.00 },
            { description: 'Vegetarian Option - Stuffed Portobello (per person)', quantity: 10, price: 24.00 },
            { description: 'Dessert - Wedding Cake Service', quantity: 75, price: 8.00 },
            { description: 'Beverage Service - Non-Alcoholic (per person)', quantity: 75, price: 6.00 },
            { description: 'Service Staff (6 servers, 6 hours)', quantity: 1, price: 720.00 },
            { description: 'Linen & Tableware Rental', quantity: 1, price: 350.00 },
            { description: 'Setup and Cleanup Fee', quantity: 1, price: 250.00 }
        ];

        // Clear existing items and add sample items
        const tbody = document.getElementById('itemsBody');
        tbody.innerHTML = '';

        sampleItems.forEach((item, index) => {
            const row = document.createElement('tr');
            row.className = 'item-row';
            const total = (item.quantity * item.price).toFixed(2);
            row.innerHTML = `
                <td>
                    <input type="text" class="form-control" name="Input.Items[${index}].Description" value="${item.description}" aria-label="Item description" />
                </td>
                <td>
                    <input type="number" class="form-control item-qty" name="Input.Items[${index}].Quantity" value="${item.quantity}" min="0" step="1" aria-label="Quantity" />
                </td>
                <td>
                    <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input type="number" class="form-control item-price" name="Input.Items[${index}].UnitPrice" value="${item.price.toFixed(2)}" min="0" step="0.01" aria-label="Unit price" />
                    </div>
                </td>
                <td>
                    <span class="item-total fw-bold">$${total}</span>
                </td>
                <td>
                    <button type="button" class="btn btn-outline-danger btn-sm remove-item" title="Remove item">
                        <i class="bi bi-x-lg" aria-hidden="true"></i>
                    </button>
                </td>
            `;
            tbody.appendChild(row);
            attachRowEvents(row);
        });

        // Notes
        document.querySelector('textarea[name="Input.Notes"]').value = 'Payment Terms: 50% deposit due upon booking, remaining balance due 7 days before the event.\n\nCancellation Policy: Full refund if cancelled 30+ days before event. 50% refund if cancelled 14-30 days before event.\n\nMenu substitutions available upon request with advance notice.';

        // Clear any validation errors since all required fields now have data
        clearAllValidation();

        // Scroll to form to show the loaded data
        const invoiceForm = document.getElementById('invoiceForm');
        if (invoiceForm) {
            invoiceForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    /**
     * Show the clear confirmation modal
     */
    function showClearConfirmation() {
        var modalEl = document.getElementById('cigClearConfirmModal');
        if (modalEl) {
            var modal = new bootstrap.Modal(modalEl);
            modal.show();
        }
    }

    /**
     * Scroll to the invoice form
     */
    function scrollToForm() {
        const form = document.getElementById('invoiceForm');
        if (form) {
            form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    /**
     * Clear all invoice data
     */
    function clearAllData() {
        // Business Information
        document.querySelector('input[name="Input.BusinessName"]').value = '';
        document.querySelector('input[name="Input.BusinessAddress"]').value = '';
        document.querySelector('input[name="Input.BusinessPhone"]').value = '';
        document.querySelector('input[name="Input.BusinessEmail"]').value = '';

        // Client Information
        document.querySelector('input[name="Input.ClientName"]').value = '';
        document.querySelector('input[name="Input.ClientAddress"]').value = '';
        document.querySelector('input[name="Input.ClientPhone"]').value = '';
        document.querySelector('input[name="Input.ClientEmail"]').value = '';

        // Event Details
        document.querySelector('input[name="Input.EventDate"]').value = '';
        document.querySelector('input[name="Input.EventTime"]').value = '';
        document.querySelector('input[name="Input.EventLocation"]').value = '';
        document.querySelector('input[name="Input.NumberOfGuests"]').value = '';
        document.querySelector('select[name="Input.EventType"]').value = '';

        // Invoice Details
        document.querySelector('input[name="Input.InvoiceNumber"]').value = '';
        document.querySelector('input[name="Input.InvoiceDate"]').value = '';
        document.querySelector('input[name="Input.DueDate"]').value = '';
        document.querySelector('input[name="Input.TaxRate"]').value = '';

        // Clear line items and add one empty row
        const tbody = document.getElementById('itemsBody');
        tbody.innerHTML = '';
        const row = document.createElement('tr');
        row.className = 'item-row';
        row.innerHTML = `
            <td>
                <input type="text" class="form-control" name="Input.Items[0].Description" aria-label="Item description" />
            </td>
            <td>
                <input type="number" class="form-control item-qty" name="Input.Items[0].Quantity" value="1" min="0" step="1" aria-label="Quantity" />
            </td>
            <td>
                <div class="input-group">
                    <span class="input-group-text">$</span>
                    <input type="number" class="form-control item-price" name="Input.Items[0].UnitPrice" value="0" min="0" step="0.01" aria-label="Unit price" />
                </div>
            </td>
            <td>
                <span class="item-total fw-bold">$0.00</span>
            </td>
            <td>
                <button type="button" class="btn btn-outline-danger btn-sm remove-item" title="Remove item">
                    <i class="bi bi-x-lg" aria-hidden="true"></i>
                </button>
            </td>
        `;
        tbody.appendChild(row);
        attachRowEvents(row);
        itemIndex = 1;

        // Notes
        document.querySelector('textarea[name="Input.Notes"]').value = '';

        // Remove the generated invoice preview
        const invoicePreview = document.getElementById('invoice-preview');
        if (invoicePreview) {
            invoicePreview.remove();
        }

        // Scroll to top of form
        const invoiceForm = document.getElementById('invoiceForm');
        if (invoiceForm) {
            invoiceForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    /**
     * Auto-scroll to invoice preview after generation
     */
    function scrollToInvoicePreview() {
        const el = document.getElementById('invoice-preview');
        if (el && typeof el.scrollIntoView === 'function') {
            window.requestAnimationFrame(function() {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init();
            scrollToInvoicePreview();
        });
    } else {
        init();
        scrollToInvoicePreview();
    }

    // Expose public API
    window.CateringInvoiceGenerator = {
        loadSampleData: loadSampleData,
        clearAllData: clearAllData,
        scrollToForm: scrollToForm
    };
})();
